$(document).ready(checkContainer);

function checkContainer() {
  if ($(".l2h-photos-container").is(":visible")) {
    //if the container is visible on the page
    var getcount = $(".l2h-photos-container").length;
    if (getcount > 0) {
      $(".l2h-photos-container").show();
      $(".get-ins").show();
      $(".get-ins").removeClass("hide");
    } else {
      $(".get-ins").hide();
    }
  } else {
    setTimeout(checkContainer, 50); //wait 50 ms, then try again
    $(".get-ins").hide();
    $(".get-ins").addClass("hide");
  }
}

$(document).ready(checkContainerr);

function checkContainerr() {
  if ($('[data-app="eastsideco_sizeGuides"] a').is(":visible")) {
    //if the container is visible on the page
    $(
      "<span class='question'><img src='https://cdn.shopify.com/s/files/1/0164/6339/6964/files/chat.png?v=1658385539'> Questions? </span><span class='chat-with-expt'><a >Chat with a stylist</a></span>"
    ).insertAfter(".esc-size-guide--table-wrap");
    $(
      "<p>Not sure about the size? We offer free 14-day returns & exchanges.</p>"
    ).insertAfter(" h5.esc-size-guide--title");
    $("span.chat-with-expt").on("click", function () {
      window.open(
        "https://v2.zopim.com/widget/popout.html?key=51HKsx5QfIMuPj1taG1H9daEBRLoNGLM",
        "popupWindow",
        "width=600,height=600,scrollbars=yes"
      );
    });
  } else {
    setTimeout(checkContainerr, 50); //wait 50 ms, then try again
  }
}
